export default "__VITE_PUBLIC_ASSET__b794614f__"